import { render, staticRenderFns } from "./CompetitionFilterJudgeLayout.vue?vue&type=template&id=60cede40&scoped=true&"
import script from "./CompetitionFilterJudgeLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterJudgeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cede40",
  null
  
)

export default component.exports